import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-item-add"
};
import { nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import products from '../services/ProductRepository';
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import CatalogItemActions from "./CatalogItemActions.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItemAdd',
    props: {
        order: {},
        addCartItems: { type: Function },
        addWatchlistItem: { type: Function },
        allowOrderingUnitSelection: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const searchRequest = ref({ query: '', filters: [] });
        const grid = ref(null);
        const source = ref(null); //= ref(products.getVariantGridItemsSource());
        const operations = ref([]);
        const showProductsSearch = ref(false);
        const working = ref(false);
        onMounted(() => {
            products.getVariantGridConfig(props.order.channel).then(g => {
                grid.value = g;
                grid.value.capabilities = { bulkOperations: false, search: true, searchQueries: true };
            });
            loadVariants();
            operations.value = [{
                    name: 'add_cart_items',
                    icon: 'cart',
                    execute: selectItemsBulk
                }];
            events.$on('command.add_cart_items.success', onAddCartItemsSuccess);
        });
        watch(() => props.order.shippingMethod, onTargetDateChange);
        onUnmounted(() => {
            events.$off('command.add_cart_items.success', onAddCartItemsSuccess);
        });
        function onTargetDateChange() {
            loadVariants();
            nextTick(() => {
                events.$emit('cart-item-add.refresh');
            });
        }
        function loadVariants() {
            source.value = products.getVariantGridItemsSource(props.order.channel, props.order.customer.catalog, props.order.customer.customerId, props.order.customer.userId, props.order.context);
        }
        function selectItem(variant) {
            // addCartItems([{
            //     sku: variant.id,
            //     quantity: 1,
            // }]);
        }
        function selectItemsBulk(params) {
            working.value = true;
            const selectedSku = params.selected();
            const excludedSku = params.excluded();
            const searchRequest = params.searchRequest;
            // individual selection? => restrict via filter
            if (selectedSku.length > 0) {
                searchRequest.filters.push({
                    attribute: 'sku',
                    operator: 'eq',
                    values: selectedSku,
                });
            }
            const page = {
                number: 0,
                size: 50,
            };
            return products.listVariants(searchRequest, page, [])
                .then(data => {
                if (data.totalPages > 1) {
                    alerts.error(trans('command.add_cart_items.too_many_items', { limit: page.size }));
                    throw 'too many items';
                }
                const items = data.content
                    .filter(item => excludedSku.indexOf(item.id) === -1)
                    .filter(item => item.details.price)
                    .map(item => {
                    return {
                        sku: item.id,
                        quantity: (item.details && item.details.defaultOrderQuantity) || 1,
                        unit: item.details.price.unitCode,
                    };
                });
                return doAddCartItems(items);
            })
                .finally(() => working.value = false);
        }
        function doAddCartItems(items) {
            working.value = true;
            return props.addCartItems(items, props.order.id)
                .finally(() => working.value = false);
        }
        function onAddCartItemsSuccess(cart) {
            if (cart && cart.id === props.order.id) {
                alerts.success(trans('command.add_cart_items.success'));
            }
        }
        return (_ctx, _cache) => {
            return (_ctx.$isGranted('PORTAL_CATALOG_VIEW'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showProductsSearch.value = !showProductsSearch.value), ["prevent"])),
                        class: _normalizeClass(["cart-item-add__products-search-toggle", { 'cart-item-add__products-search-toggle--active': showProductsSearch.value }]),
                        href: ""
                    }, [
                        _createVNode(Icon, { name: "search" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('order.add_item')) + " ", 1),
                        (showProductsSearch.value)
                            ? (_openBlock(), _createBlock(Icon, {
                                key: 0,
                                name: "angle-up"
                            }))
                            : _createCommentVNode("", true)
                    ], 2),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    (showProductsSearch.value && grid.value && source.value)
                        ? (_openBlock(), _createBlock(DataTable, {
                            key: 0,
                            name: "cart-item-add",
                            "search-request": searchRequest.value,
                            grid: grid.value,
                            source: source.value,
                            "bulk-operations": operations.value,
                            variant: "condensed",
                            onActivateItem: selectItem
                        }, {
                            "item-actions": _withCtx((props) => [
                                _createVNode(CatalogItemActions, {
                                    "add-cart-items": __props.addCartItems,
                                    "add-watchlist-item": __props.addWatchlistItem,
                                    "allow-ordering-unit-selection": __props.allowOrderingUnitSelection,
                                    cart: __props.order,
                                    item: props['item']
                                }, null, 8, ["add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection", "cart", "item"])
                            ]),
                            _: 1
                        }, 8, ["search-request", "grid", "source", "bulk-operations"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
